// extracted by mini-css-extract-plugin
var _1 = "PostViewBanner-module__animatedBackground--cIqIA";
var _2 = "PostViewBanner-module__banner--Cw3LH";
var _3 = "PostViewBanner-module__container--ZLhfb";
export { _1 as "animatedBackground", _2 as "banner", _3 as "container" }
